import { search } from './searchService';
import { post, put, getById } from './apiService';
import type { Property } from '../types/property';
import type { SearchParams } from '../types/search';

export interface PropertyFilter {
  clientId?: string;
}

export async function searchProperties(
  filter: PropertyFilter = {},
  params: SearchParams = {},
): Promise<Property[]> {
  return search<Property>('/property/search', filter, params);
}

export async function getPropertyById(id: string): Promise<Property> {
  return getById<Property>('/property', id);
}

export async function createProperty(data: {
  clientId: string;
  name: string;
  address: string;
  toNumber?: string;
  websiteUrl?: string;
  timezone?: string;
}): Promise<Property> {
  return post<Property>('/property', data);
}

export async function updateProperty(id: string, data: Property): Promise<Property> {
  return put<Property>(`/property/${id}`, data);
}
